import { Injectable } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { authEvents } from '../+state/auth/events';
import { paymentEvents } from '../+state/payment/events';
import { globalEvents } from '../+state/global/events';
import { jobEvents } from '../+state/job/events';
import { notificationEvents } from '../+state/notification/events';
import { bookingEvents } from '../+state/booking/events';
import { userEvents } from '../+state/user/events';
import { shareLinkEvents } from '../+state/share-link/events';

/**
 * Dispatches `clear` on feature stores after logout.
 * Must not inject any `*Store` here — that creates a circular DI graph with `AuthStore`.
 */
@Injectable({ providedIn: 'root' })
export class CleanUpService {
  private readonly authDispatch = injectDispatch(authEvents);
  private readonly bookingDispatch = injectDispatch(bookingEvents);
  private readonly globalDispatch = injectDispatch(globalEvents);
  private readonly jobDispatch = injectDispatch(jobEvents);
  private readonly notificationDispatch = injectDispatch(notificationEvents);
  private readonly paymentDispatch = injectDispatch(paymentEvents);
  private readonly userDispatch = injectDispatch(userEvents);
  private readonly shareLinkDispatch = injectDispatch(shareLinkEvents);

  /** Clears feature stores only. Auth reset is handled by the logout effect. */
  cleanupAppStores(): void {
    this.bookingDispatch.clear();
    this.globalDispatch.clear();
    this.jobDispatch.clear();
    this.notificationDispatch.clear();
    this.paymentDispatch.clear();
    this.userDispatch.clear();
    // Share links are live capability tokens: never leave them for the next user.
    this.shareLinkDispatch.clear();
  }

  /** @deprecated Prefer the `logout` event; clears auth + app stores. */
  cleanup(): void {
    this.authDispatch.clear();
    this.cleanupAppStores();
  }
}
